import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useAdminArticleDetailStore } from '@features/admin/articles/useAdminArticleDetailStore.ts';
import ArticleDetailPage from '@features/admin/articles/ArticleDetailPage.tsx';

const paramsSchema = z.object({
  articleId: z.coerce.number().positive(),
});

const searchSchema = z.object({
  tab: z.enum(['detail', 'notifications']).optional().default('detail'),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export const Route = createFileRoute('/admin/articles/$articleId')({
  params: {
    parse: v => paramsSchema.parse(v),
  },
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: async ({ params, search }) => {
    const articleId = paramsSchema.parse(params).articleId;
    const store = useAdminArticleDetailStore.getState();

    await store.loadArticleDetail(articleId);

    if (search.tab === 'notifications') {
      await store.loadNotifications(articleId, { page: search.page, size: search.size });
    }
  },
});

function RouteComponent() {
  const { articleId } = Route.useParams();
  return <ArticleDetailPage articleId={articleId} />;
}
